import React from 'react';
import { Button, Form, Row, Col, Modal, InputGroup } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { BIEUMAUTIENSI_API } from '../../../../utils/apiUrl';
import { Post } from '../../../../utils/httpProvider';
import Editor from '../../../../components/editor/Editor';

const schema = yup.object().shape({
    tenBieuMau: yup.string().required('Vui lòng nhập tên biểu mẫu'),
    moTa: yup.string(),
    duongDanDrive: yup.string().required('Vui lòng nhập đường dẫn Drive')
});

const BieuMauTienSiAdd = ({ setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) => Post(BIEUMAUTIENSI_API.CREATE, null, value, false));

    const handleCreate = (values, { setSubmitting }) => {
        const requestData = {
            TenBieuMau: values.tenBieuMau || null,
            MoTa: values.moTa || null,
            DuongDanDrive: values.duongDanDrive || null
        };

        addFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.id)) {
                    toast.success('Thêm mới thành công');
                    queryClient.invalidateQueries(['bieuMauTienSiData']);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Thêm mới Biểu mẫu tiến sĩ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleCreate}
                    initialValues={{
                        tenBieuMau: '',
                        moTa: '',
                        duongDanDrive: ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tên biểu mẫu <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="tenBieuMau"
                                            value={values.tenBieuMau}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Nhập tên biểu mẫu..."
                                        />
                                        {touched.tenBieuMau && !!errors.tenBieuMau && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenBieuMau}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Đường dẫn Drive <span className="text-danger">*</span></Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                name="duongDanDrive"
                                                value={values.duongDanDrive}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="Link tới Google Drive hoặc dịch vụ lưu trữ khác"
                                            />
                                            {values.duongDanDrive && (
                                                <InputGroup.Append>
                                                    <a 
                                                        href={values.duongDanDrive.startsWith('http') ? values.duongDanDrive : `http://${values.duongDanDrive}`} 
                                                        target="_blank" 
                                                        rel="noreferrer" 
                                                        className="btn btn-outline-primary"
                                                        title="Mở link"
                                                    >
                                                        <i className="fas fa-external-link-alt"></i>
                                                    </a>
                                                </InputGroup.Append>
                                            )}
                                        </InputGroup>
                                        {touched.duongDanDrive && !!errors.duongDanDrive && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.duongDanDrive}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Mô tả</Form.Label>
                                        <Editor
                                            name="moTa"
                                            value={values.moTa}
                                            onChange={(val) => setFieldValue('moTa', val)}
                                        />
                                        {touched.moTa && !!errors.moTa && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.moTa}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="text-right mt-3">
                                <Button
                                    variant="secondary"
                                    onClick={() => setViewMode('list')}
                                    className="mr-2"
                                    disabled={isSubmitting}
                                >
                                    Hủy
                                </Button>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? <><i className="fas fa-spinner fa-spin mr-1"></i> Đang lưu...</> : 'Lưu lại'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default BieuMauTienSiAdd;
